import { ceiling, numCases } from "@/utils";

export const mapOutcomes = (outcomes, score, maxScore, roles) => {
  return outcomes.map((outcome) => {
    const role = roles.find((r) => r.id === outcome.role_id);
    return {
      roleName: role ? role.name : `Unknown Role ${outcome.role_id}`,
      ...getOutcomeScore(score, outcome.coefficient, maxScore),
    };
  });
};

/**
 *
 * @param {number} baseScore
 * @param {number} coef - 1 по умолчанию
 */
const getOutcomeScore = (baseScore, coef = 1, max = 0) => {
  // если коэффициент не найден, то КК считает его равным 1 по умолчанию
  const score = ceiling(baseScore * coef, 0.1, 2);
  /**
   * если есть ограничиваюющее значение max то расчетное значение не должно быть больше него
   */
  const maxScore = !!max && score > max ? max : score;
  return {
    maxScore,
    maxScoreText: `до ${maxScore} ${numCases(
      ["балла", "баллов", "баллов"],
      maxScore
    )}`,
  };
};
